/* eslint-disable */
const translation = require('./de.json');

export const de = {
    ...translation,
};
